import React from 'react';
import { ScrollReveal } from '../components/ScrollReveal';
export function MysticalSection() {
  return <section className="bg-transparent relative z-10 py-12 px-6 overflow-hidden" data-id="element-133">
      {/* Large faint moon watermark */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-lunar-white opacity-[0.02] blur-3xl pointer-events-none" data-id="element-134"></div>

      <ScrollReveal className="max-w-3xl mx-auto flex flex-col items-center text-center relative z-10" data-id="element-135">
        <p className="text-violet uppercase tracking-widest text-sm font-semibold mb-6 text-glow-violet" data-id="element-136">
          The Ancient Power Behind The Method
        </p>

        <h2 className="font-playfair text-gold text-4xl md:text-5xl font-bold leading-tight mb-12 italic" data-id="element-137">
          This Isn't New.
          <br data-id="element-138" />
          The Wisest Women in History
          <br data-id="element-139" />
          Have Always Known This.
        </h2>

        <div className="text-lunar-lavender text-lg md:text-xl leading-[2] font-fell italic space-y-6 max-w-2xl" data-id="element-140">
          <p data-id="element-141">
            Long before neuroscience gave it a name,
            <br data-id="element-142" />
            the women who came before us understood:
          </p>

          <p data-id="element-143">
            The hours between midnight and dawn
            <br data-id="element-144" />
            are sacred hours.
          </p>

          <p data-id="element-145">
            The veil between who you are
            <br data-id="element-146" />
            and who you are becoming
            <br data-id="element-147" />
            is thinnest while the world sleeps.
          </p>

          <p data-id="element-148">
            Ancient healers, mystic women,
            <br data-id="element-149" />
            and sacred feminine traditions across cultures
            <br data-id="element-150" />
            used the sleep state as a portal —<br data-id="element-151" />
            not to escape reality,
            <br data-id="element-152" />
            but to architect it.
          </p>

          <p data-id="element-153">
            The Midnight Magnet Script carries
            <br data-id="element-154" />
            this ancient knowing into your modern bedroom.
          </p>

          <p data-id="element-155">
            It is a bridge between your current reality
            <br data-id="element-156" />
            and the love that already exists for you
            <br data-id="element-157" />
            in the field of infinite possibility.
          </p>
        </div>

        <div className="my-16 text-gold text-2xl tracking-[0.5em] opacity-70" data-id="element-158">
          🌑 🌒 🌓 🌔 🌕 🌖 🌗 🌘 🌑
        </div>

        <div className="relative" data-id="element-159">
          <div className="absolute inset-0 bg-violet opacity-20 blur-2xl rounded-full" data-id="element-160"></div>
          <p className="relative font-playfair text-2xl md:text-3xl text-gold font-bold leading-relaxed max-w-2xl text-glow-gold" data-id="element-161">
            "You are not broken. You are not unlucky in love. You are simply
            operating at the wrong frequency. Tonight, we change that."
          </p>
        </div>
      </ScrollReveal>
    </section>;
}